import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Bar } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/BarChart/components/Bar.js';
import { Container } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/BarChart/components/Container.js';
export const BarChart = ({
  values
}) => {
  const max = Math.max(...values);
  return _jsx(Container, {
    columns: values.length,
    children: values.map((value, index) => _jsx(Bar, {
      style: {
        height: `${value / max * 100}%`
      }
    }, index))
  });
};